export default __webpack_public_path__ + "static/media/x.1f5bd3e2.svg";